module.exports = __webpack_public_path__ + "img/start-ups.ec149e6e.svg";